'use client';
import { getCustomer } from '@/src/lib/customer/requests/get-customer';
import { createGlueClient } from '@/src/lib/http/client/client.glue';

type CustomerInclude = 'companies';

export const getCustomerClient = async (include: Array<CustomerInclude> = [], guestId?: string) => {
  return getCustomer(include, createGlueClient(), guestId);
};
